import React from "react";
import { useCurrentWidth } from "../../../assets/utils/hooks";
import ParentElement from "../../hoc/withParentElementSwitch";
import "./index.scss";

export default function SectionCardStraight({ data }) {
	const width = useCurrentWidth();

	return ParentElement(
		data?.map(({ imageSource, heading, description, linkTo }) => (
			<div
				key={heading}
				className={
					width < 768 ? "section-item carousel-item" : undefined
				}
			>
				<li>
					{imageSource && (
						<img
							src={imageSource}
							alt=""
							className={
								!heading && !description
									? "full-height"
									: undefined
							}
						/>
					)}

					{heading && description && (
						<div
							className={!imageSource ? "full-width" : undefined}
						>
							<h4>{heading}</h4>

							<p className="small text-justify">{description}</p>

							<a
								href={linkTo ? linkTo : "/"}
								target={linkTo && "#"}
							>
								Learn more
							</a>
						</div>
					)}
				</li>
			</div>
		)),
		data.length
	);
}
